module.exports = "<div class=\"box box-border\"> <div class=box-hd> <h3 translate>Tags</h3> </div> <div class=box-bd> <ul class=\"list list-horizontal\"> <li ng-repeat=\"tag in ::vm.tags\"><a ui-sref=\"newsbytag({id: tag.id})\" class=\"btn btn-outline btn-small\">{{::tag.name}}</a></li> </ul> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-tags.html
// module id = 607
// module chunks = 0